import * as S from './styles'

import { FormControl, InputGroup } from 'react-bootstrap'
import { Control, FieldValues, Path, useController } from 'react-hook-form'

export function BootstrapInput<T extends FieldValues>({
  name,
  label,
  control,
  type = 'text',
  units,
  onValueChange,
  tooltip,
  ...props
}: {
  control: Control<T, any>
  name: Path<T>
  label?: string
  placeholder?: string
  type?: string
  units?: string
  /** Optional side-channel called with the raw new value on each change,
   * for callers that need to react (e.g. autofill a sibling field). */
  onValueChange?: (value: string) => void
  /** Optional node rendered next to the label (e.g. a HelpTooltip). */
  tooltip?: React.ReactNode
}) {
  const {
    field: { onChange, value },
    fieldState: { error },
  } = useController({ ...props, name: name, control })

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue =
      type === 'number'
        ? onlyNumericCharacters(event.target.value)
        : event.target.value
    //TODO: do not convert to Number() because it screws up everything
    onChange(newValue)
    onValueChange?.(newValue)
  }

  return (
    <div className={'mb-2'}>
      {tooltip ? (
        <div className="flex items-center gap-1">
          <S.Label htmlFor={name}>{label}</S.Label>
          {tooltip}
        </div>
      ) : (
        <S.Label htmlFor={name}>{label}</S.Label>
      )}
      <InputGroup>
        {units === '$' ? <InputGroup.Text>$</InputGroup.Text> : null}
        <FormControl
          id={name}
          onChange={handleChange}
          type="text"
          value={value?.toString() || ''}
        />
        {units === '%' ? <InputGroup.Text>%</InputGroup.Text> : null}
      </InputGroup>
      <p className="text-fg">{error?.message ?? ''}</p>
    </div>
  )
}

// create a function that takes a string and returns only numeric characters
function onlyNumericCharacters(value: string) {
  return value.replace(/[^0-9.]/g, '')
}
